import { Alert } from "@mui/material";
import type { WorkbookRunStatus } from "../../../../../api/types/workbookRuns.types";

interface Props {
  status: WorkbookRunStatus;
}

const WorkbookRunDetailsAlert = ({ status }: Props) => {
  if (status === "InProgress") {
    return (
      <Alert severity="info">
        The workbook is being updated in the background. You’ll be able to download the file once it’s ready.
      </Alert>
    );
  }
  if (status === "Error") {
    return (
      <Alert severity="error">
        An error occurred while updating the workbook. <br /> Try creating a new run; if the issue repeats, contact
        support.
      </Alert>
    );
  }

  return null;
};

export default WorkbookRunDetailsAlert;
